import { render, staticRenderFns } from "./appAdvertising.vue?vue&type=template&id=c640d0ac&scoped=true&"
import script from "./appAdvertising.vue?vue&type=script&lang=js&"
export * from "./appAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./appAdvertising.vue?vue&type=style&index=0&id=c640d0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c640d0ac",
  null
  
)

export default component.exports